export const RICHTEXT = 'richtext';
export const IMAGE = 'image';
export const LINK = 'link';
export const HTML_EMBED = 'html_embed';
